import type { LocationQueryRaw, RouteLocationRaw } from 'vue-router';

export function resolveSideMenuRouteLocation(to: string, query?: LocationQueryRaw): RouteLocationRaw {
    return to.startsWith('/') ? { path: to, query } : { name: to, query };
}
